import React from 'react';
import { postContainer, resetRedux } from 'actions/SnacksWMS';
import { connect } from 'react-redux';
import { sendNotification } from 'actions/Notifications.js';
import ContainerHeader from 'components/ContainerHeader';
import IntlMessages from 'utils/IntlMessages';
import RegisterPack from '../components/RegisterPack';

class RegisterSnackPack extends React.Component {
	render() {
		return (
			<div className="app-wrapper">
				<ContainerHeader
					location={this.props.location}
					title={<IntlMessages id="pages.wms.snacks" />}
					showBreadcrumb
					backButton
				/>
				<RegisterPack {...this.props} productType="snacks" />
			</div>
		);
	}
}
const mapStateToProps = state => ({
	finish: state.snacksWMS.finish,
	storage: state.snacksWMS.storage,
	loading: state.snacksWMS.loading,
	error: state.snacksWMS.error,
	check: state.snacksWMS.check,
});

export default connect(mapStateToProps, {
	postContainer,
	sendNotification,
	resetRedux,
})(RegisterSnackPack);
